module.exports = __webpack_public_path__ + "img/people-10.fc9a5718.png";